import React from "react";
import LoadingStates from "../../constants/states/LoadingStates";
import PrivateMySpacesStore from "../../stores/PrivateMySpacesStore";
import EventPublisher from "../../utils/EventPublisher";
import StoreUpdateEvents from "../../constants/events/StoreUpdateEvents";
import UIInteractionEvents from "../../constants/events/UIInteractionEvents";
import ListedSpacesTableView from "../views/ListedSpacesTableView";
import UnlistedSpacesTableView from "../views/UnlistedSpacesTableView";
import LoadingView from "../views/LoadingView";

class MySpacesContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            "privateMySpacesStore": PrivateMySpacesStore.getState(),
        };
    }

    componentDidMount() {
        this.privateMySpacesStoreSubscriber =
            EventPublisher.subscribe(StoreUpdateEvents.PRIVATE_MY_SPACES_STORE_UPDATE, this.handleStoreUpdate);
        EventPublisher.publish(UIInteractionEvents.GET_MY_SPACES, {});
    }

    componentWillUnmount() {
        EventPublisher.unsubscribe(this.privateMySpacesStoreSubscriber);
        EventPublisher.publish(UIInteractionEvents.MY_SPACE_UNMOUNTED, {});
    }

    handleStoreUpdate = (topic, data) => {
        this.setState({
            "privateMySpacesStore": PrivateMySpacesStore.getState(),
        });
    };

    render() {
        if (this.state.privateMySpacesStore.mySpacesLoadingState !== LoadingStates.FINISHED_LOADING) {
            return (
                <LoadingView titleText="Loading Spaces"/>
            );
        }

        const hash = this._getHashOrDefault();

        return (
            <div className="container mt-13vh p-0 w-100">
                <div className="row">
                    <div className="col-12">
                        <div className="card">
                            <div className="card-header">
                                <div className="row">
                                    <div className="col-12">
                                        <ul className="nav nav-tabs card-header-tabs" id="bologna-list" role="tablist">
                                            <li className="nav-item">
                                                <button
                                                    className={(hash === "#listed-spaces") ? "btn nav-link active": "btn nav-link"}
                                                    id="nav-listed-spaces-tab"
                                                    onClick={(e) => this._changeHashTo(e, "#listed-spaces")}
                                                    role="tab"
                                                    aria-controls="nav-listed-spaces"
                                                    aria-selected="true"
                                                >
                                                    Listed Spaces
                                                </button>
                                            </li>
                                            <li className="nav-item">
                                                <button
                                                    className={(hash === "#unlisted-spaces") ? "btn nav-link active": "btn nav-link"}
                                                    id="nav-unlisted-spaces-tab"
                                                    onClick={(e) => this._changeHashTo(e, "#unlisted-spaces")}
                                                    role="tab"
                                                    aria-controls="unlisted-spaces"
                                                    aria-selected="false"
                                                >
                                                    Unlisted Spaces
                                                </button>
                                            </li>
                                            <li className="nav-item ml-auto mr-2">
                                                <button
                                                    type="button"
                                                    className="btn btn-cuvered-pink float-right"
                                                    onClick={() => this.handleNewSpaceButtonClick()}
                                                >
                                                    <i className="fas fa-plus mr-1" />
                                                    Create New
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body">
                                <h4 className="card-title">My Spaces</h4>

                                <div className="tab-content mt-3">
                                    <div className={(hash === "#listed-spaces") ? "tab-pane active": "tab-pane fade"} id="listed-spaces" role="tabpanel" aria-labelledby="nav-listed-spaces-tab">
                                        {<ListedSpacesTableView spaces={this.state.privateMySpacesStore.listedSpaces}/>}
                                    </div>
                                    <div className={(hash === "#unlisted-spaces") ? "tab-pane active": "tab-pane fade"} id="unlisted-spaces" role="tabpanel" aria-labelledby="nav-unlisted-spaces-tab">
                                        {<UnlistedSpacesTableView spaces={this.state.privateMySpacesStore.unlistedSpaces}/>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    _changeHashTo(event, newHash) {
        event.stopPropagation();
        window.location.hash = newHash;
    }

    _getHashOrDefault() {
        const hash = window.location.hash
        if(hash === "#unlisted-spaces") {
            return hash;
        }
        return "#listed-spaces";
    }

    handleNewSpaceButtonClick = () => {
        EventPublisher.publish(UIInteractionEvents.MY_SPACES_NEW_SPACE_BUTTON_CLICKED, {});
    }
}

export default MySpacesContainer;